














import {Vue, Component} from 'vue-property-decorator'
import {Mutation, State} from "vuex-class";
import {formatDate} from "@/utils/formatters";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class Zalihe extends mixins(ComponentBaseMixin) {
  @State menuCollapsed;
  @Mutation setMenuCollapsed;
  selectedCriteria = 0;
  quantity = 12;
  columns = [];
  zalihe = [];
  tableOptions = {
    sortable: true,
    pagination: true,
    pageSize: 50,
    loadingFontSize: `${14}px`,
    search: true,
    showExport: true,
    exportTypes: ['excel']
  };
  isBusy = false;

  async created() {
    this.setMenuCollapsed(true);
    this.columns = [
      {field: 'storeName', title: this.$i18n.t('objekat'), sortable: true},
      {field: 'address', title: this.$i18n.t('adresa'), sortable: true},
      {field: 'city', title: this.$i18n.t('mesto'), sortable: true},
      {field: 'product', title: this.$i18n.t('artikal'), sortable: true},
      {field: 'stock', title: this.$i18n.t('zaliha'), sortable: true, align: 'right'},
      {
        field: 'lastVisitDate',
        title: this.$i18n.t('datumPoslednjePosete'),
        sortable: true,
        align: 'right',
        formatter: value => value ? formatDate(value) : ''
      },
      {field: 'daysSinceLastVisit', title: this.$i18n.t('preDana'), sortable: true, align: 'right'},
    ];
    await this.pretraziZalihe();
  }

  async pretraziZalihe() {
    if (this.isBusy) return;
    this.zalihe = [];
    let table = $('#zaliheTable');
    table.bootstrapTable('showLoading');
    this.isBusy = true;
    try {
      const { data } = await this.axios.get('api/GetStockReport');
      this.zalihe = data;
    } catch(err) {
      this.showError('neuspesnoUcitavanjePodataka');
      this.isBusy = false;
      table.bootstrapTable('hideLoading');
    } finally {
      this.isBusy = false;
      table.bootstrapTable('hideLoading');
    }
  }
}
